<template>
    <div class="am-add-task">
        <div class="am-task-title-bar">
            <span class="am-task-title"><strong>Add Task</strong></span>
        </div>

        <form class="am-task-form" method="POST" action="http://127.0.0.1:8000/tasks">
            <div>
                <table class="am-task-edit-results">
                    <tbody>

                        <tr>
                            <td class="am-task-problue">
                                <strong>Task Details</strong>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Type of Task:</strong></td>
                            <td>
                                <select name="type">
                                    <option v-for="type in types" :value="type.id" :key="type.id">{{ type.value }}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Review Required:</strong></td>
                            <td>
                                <input name="review_required" type="checkbox"/>
                            </td>
                        </tr>
                        <tr>
                            <td><strong><span> Customer Number</span>:</strong></td>
                            <input type="text" class="input" name="custid">
                        </tr>
                        <tr>
                            <td>
                                <strong>To:</strong>
                            </td>
                            <td>
                                <select name="touser">
                                    <option v-for="user in users" :value="user.id" :key="user.id">{{user.value}}</option>

                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Due Date:</strong></td>
                            <td><input type="date" name="duedate"></td>
                        </tr>
                        <tr>
                            <td><strong>Task Time:</strong></td>
                            <td><input type="text" name="tasktime"></td>
                        </tr>
                        <tr>

                            <td><strong>Duration:</strong></td>
                            <input type="range" min="0" max="480" value="0" class="am-task-slider" id="myRange">
                        </tr>
                        <tr>
                            <td><strong>Priority:</strong></td>
                            <td>
                                <select name="priorities">
                                    <option v-for="priority in priorities" :value="priority.key" :key="priority.id">{{priority.value}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Status:</strong></td>
                            <td>
                                <select name="status">
                                    <option v-for="status in statusID" :value="status.key" :key="status.id">{{status.value}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>
                                    <span>Task Description:</span>
                                </strong>
                                <br>
                                <speech-to-text-input>
                                    <textarea name="notes" rows="5" cols="28"></textarea>
                                </speech-to-text-input>
                            </td>
                            <td class="am-task-icon-button">
                                <button><span><font-awesome-icon icon="microphone"/></span></button>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <button type="button" v-if="!isHidden" v-on:click="isHidden = true">Add Note</button>

                            </td>
                        </tr>
                        <tr v-if="isHidden">
                            <td>
                                <strong>
                                    <span>Task Notes:</span>
                                </strong>
                                <br>
                                <speech-to-text-input>
                                    <textarea name="notes" rows="5" cols="28"></textarea>
                                </speech-to-text-input>
                            </td>
                            <td class="am-task-icon-button">
                                <button><span><font-awesome-icon icon="microphone" /></span></button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <input type="hidden" name="fromuser" :value="$store.state.auth.user.id">

          <div class="am-task-buttonbar"></div>
          <div class="floatLeft am-task-buttons">
            <button type="submit">Save</button>&nbsp;
            <button type="submit">Save & Close</button>
          </div>
          <div class="floatRight am-task-buttons">
            <button type="button" @click="closeModal()">Cancel</button>
          </div>

        </form>

    </div>

</template>

<script>
import Headerbar from './Headerbar'
export default {
  components: { Headerbar },
  data: function () {
    return {
      name: 'task',
      types: [
        {
          id: 1,
          key: 'one',
          value: 'Task Type One'
        },
        {
          id: 2,
          key: 'two',
          value: 'Task Type Two'
        },
        {
          id: 3,
          key: 'three',
          value: 'Task Type Three'
        }
      ],
      users: [
        {
          id: 188218,
          key: 188218,
          value: 'User One'
        },
        {
          id: 2,
          key: 'user2',
          value: 'User Two'
        },
        {
          id: 3,
          key: 'user3',
          value: 'User Three'
        }
      ],
      priorities: [
        {
          id: 1,
          key: 'urgent',
          value: 'Urgent'
        },
        {
          id: 2,
          key: 'high',
          value: 'High'
        },
        {
          id: 3,
          key: 'normal',
          value: 'Normal'
        }
      ],
      statusID: [
        {
          id: 1,
          key: '1st Attempt',
          value: '1st Attempt - TEXT'
        },
        {
          id: 2,
          key: '2nd Attempt',
          value: '2nd Attempt - EMAIL'
        },
        {
          id: 3,
          key: '3rd Attempt',
          value: '3rd Attempt - CALL '
        }
      ],

      isHidden: false

    }
  },

  methods: {
    closeModal () {
      this.$parent.showAddModal = false
    }
  }
}
</script>

<style scoped>

    .am-task-slider {
        -webkit-appearance: none;
        width: 100%;
        height: 7px;
        background: white;
        border: 1px solid #4297d7;
        border-radius: 10px;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
    }

    .am-task-slider:hover {
        opacity: 1;
    }

    .am-task-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 12px;
        height: 12px;
        background: #4297d7;
        border-radius: 14px;
        cursor: pointer;
    }

    .am-task-slider::-webkit-slider-thumb:hover {
        background: #87bb00;
    }

    .am-add-task {
        position: absolute;
        height: auto;
        width: auto;
        top: 18%;
        left: 40%;
        display: block;
        border-radius: 4px;
        border: 1px solid #4297d7;
        background-color: #fcfdfd;
        margin: 0;
    }

    .am-task-title-bar {
        display: block;
        height: 35px;
        width: auto;
        border-radius: 1px;
        background: #2a95cc;
    }

    .am-task-title {
        font-size: 14px;
        color: #FDFEFE;
        float: left;
        margin-top: 5px;
        margin-left: 10px;

    }

    .am-task-edit-results input, select, textarea{
        background-color: #ffffef;
    }

    .am-task-form {
        font-size: 11px;
        margin-left: 20px;
        margin-top: 7px;
        overflow: auto;
        margin-right: 20px;
    }

    .am-task-form input {
        max-width: 95%;
    }

    .am-task-form select {
        max-width:110px;
    }

    .am-task-problue {
        color: #4297d7;
    }

    .am-task-buttons {
        margin-bottom:8px;
        margin-right: 10px;
        margin-left: 10px;
        margin-top: 8px;

    }

    .am-task-buttonbar {
        display: block;
        border-top: 1px solid #4297d7;
        margin-top: 18px;
    }

    .floatLeft {
        float:left;
    }

    .floatRight {
        float:right;
    }

    .am-task-icon-button {
        margin-top: 20px;
        font-size: 11px;
        margin-right: 88px;
        float: right;
    }

    .am-task-icon-button span {
        padding: 18px 4px 18px;
    }

</style>
